
import { DeviceType } from '@/store/modules/app/state'
import { computed, defineComponent, onBeforeMount, onBeforeUnmount, onMounted, reactive, toRefs } from 'vue'
import { useStore } from '@/store'
import { useRouter } from 'vue-router'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { AppMain, Sidebar, Header, Navbar } from './components'
import MerchantRefundDialog from './components/merchant-dialog/MerchantRefundDialog.vue'
// import { AppMain, Navbar, Settings, TagsView, Sidebar } from './components'
import RightPanel from '@/components/right_panel/Index.vue'
import resize from './resize'
import { UserType } from '@/enums/user'
import { ElNotification } from 'element-plus'

export default defineComponent({
name: 'Layout',
components: { AppMain, Sidebar, Header, Navbar, MerchantRefundDialog },
setup() {
const store = useStore()
const router = useRouter()
const { sidebar, device, addEventListenerOnResize, resizeMounted, removeEventListenerResize } = resize()

const state = reactive({
    handleClickOutside: () => {
    // store.dispatch(AppActionTypes.ACTION_CLOSE_SIDEBAR, false)
    }
})

const userType = store.state.user.userInfo.user_type as number

const loading = computed(() => {
    return store.state.app.globalLoading
})

const classObj = computed(() => {
    return {
    hideSidebar: !sidebar.value.opened,
    openSidebar: sidebar.value.opened,
    withoutAnimation: sidebar.value.withoutAnimation,
    mobile: device.value === DeviceType.Mobile
    }
})

// const showSettings = computed(() => {
//   return store.state.settings.showSettings
// })
const showTagsView = computed(() => {
    return false
//   return store.state.settings.showTagsView
})
// const fixedHeader = computed(() => {
//   return store.state.settings.fixedHeader
// })

// 用户30分钟无操作退出登录，商户类用户12小时自动退出
const checkCookieTime = () => {
    let lastCookieTime = parseInt(localStorage.getItem('last-cookie-time') || '')
    if ((userType != 2 && lastCookieTime && new Date().getTime() - lastCookieTime < 30 * 60 * 1000) || (userType == 2 && lastCookieTime && new Date().getTime() - lastCookieTime < 12 * 60 * 60 * 1000)) {
        localStorage.setItem('last-cookie-time', new Date().getTime().toString())
    } else {
        localStorage.setItem('last-cookie-time', new Date().getTime().toString())
        ElNotification.closeAll() // 关闭所有通知
        // @ts-ignore
        store.dispatch(UserActionTypes.ACTION_LOGOUT)
        router.push(`/login`)
    }
}

document.addEventListener('keydown', () => {
    checkCookieTime()
})
document.addEventListener('mousedown', () => {
    checkCookieTime()
})

onBeforeMount(() => {
//   addEventListenerOnResize()
})

onMounted(() => {
//   resizeMounted()
})

onBeforeUnmount(() => {
//   removeEventListenerResize()
})

return {
    loading,
    classObj,
    sidebar,
//   showSettings,
    showTagsView,
//   fixedHeader,
    UserType,
    userType,
    ...toRefs(state)
}
}
})
